export const south_carolina = {
  "45000": "South Carolina",
  "45001": "Abbeville County",
  "45003": "Aiken County",
  "45005": "Allendale County",
  "45007": "Anderson County",
  "45009": "Bamberg County",
  "45011": "Barnwell County",
  "45013": "Beaufort County",
  "45015": "Berkeley County",
  "45017": "Calhoun County",
  "45019": "Charleston County",
  "45021": "Cherokee County",
  "45023": "Chester County",
  "45025": "Chesterfield County",
  "45027": "Clarendon County",
  "45029": "Colleton County",
  "45031": "Darlington County",
  "45033": "Dillon County",
  "45035": "Dorchester County",
  "45037": "Edgefield County",
  "45039": "Fairfield County",
  "45041": "Florence County",
  "45043": "Georgetown County",
  "45045": "Greenville County",
  "45047": "Greenwood County",
  "45049": "Hampton County",
  "45051": "Horry County",
  "45053": "Jasper County",
  "45055": "Kershaw County",
  "45057": "Lancaster County",
  "45059": "Laurens County",
  "45061": "Lee County",
  "45063": "Lexington County",
  "45065": "McCormick County",
  "45067": "Marion County",
  "45069": "Marlboro County",
  "45071": "Newberry County",
  "45073": "Oconee County",
  "45075": "Orangeburg County",
  "45077": "Pickens County",
  "45079": "Richland County",
  "45081": "Saluda County",
  "45083": "Spartanburg County",
  "45085": "Sumter County",
  "45087": "Union County",
  "45089": "Williamsburg County",
  "45091": "York County",
};
